const axios = require('axios');

export function sendGetRequest(pUrl) {
  return axios.get(pUrl);
};




// WEBPACK FOOTER //
// ./src/utils/axios.js